/* A372 — dimension filters as a range, not a checkbox per millimetre.
 *
 * Shopify has no range filter for a metafield: `...product_width_mm.gte=600`
 * is silently ignored and returns the unfiltered collection. The only shape it
 * honours is the repeated exact value. So this reads the values the theme has
 * already rendered as checkboxes, replaces them with one range control, and on
 * apply submits every value inside the range as its own parameter.
 *
 * Everything downstream stays native: Shopify does the filtering, the paging
 * and the counts, and the checkbox list is still in the DOM for anyone without
 * JavaScript.
 */
(function () {
  'use strict';
  if (window.__rbDimRange) { return; }
  window.__rbDimRange = true;

  /* The size metafields, in both shapes. Matching on the PARAM name, not the
     label, because the label is merchant-typed in the Search & Discovery app
     and can be renamed; the param is the metafield key and cannot.
       custom.product_width_mm    exact sizes  -> "600"
       custom.product_width_band  50mm bands   -> "0600-0649"
     Bands are what A372 moved to, because one drag then costs 7 parameters
     instead of 115 and the page stays its normal weight. The exact shape is
     still handled so the control keeps working on any store, and during the
     window where both filters are switched on. */
  var PARAM_RE = /_(mm|band)$/;
  /* Under this many sizes a plain list is friendlier than a slider, and a
     slider over two values is faintly ridiculous. */
  var MIN_VALUES = 4;
  var BARS = 30;

  /* ☠️ EVERY size in the catalogue, baked in at deploy time — NOT the sizes the
     sidebar rendered. Shopify displays at most 100 values per filter and drops
     the rest, keeping the commonest: CE has 624 distinct widths but any one
     collection page shows 100. Ticking only what was rendered would inherit
     that blindness — in the 500-800mm band alone it costs 223 of 990 products.
     The 100 is a DISPLAY cap; applying more than 100 works fine. */
  var STORE = {"custom.product_width_mm":[40,42,50,78,90,100,105,110,115,125,138,140,145,150,154,155,160,165,175,176,177,180,190,192,195,197,198,200,203,205,206,208,210,215,216,220,225,226,228,230,235,236,240,245,246,247,249,250,252,253,254,255,260,264,265,266,270,272,275,279,280,282,285,288,290,293,295,296,297,298,299,300,302,305,310,312,315,318,320,324,325,326,328,329,330,332,333,335,336,337,338,340,342,345,346,348,350,352,353,355,356,360,361,362,365,367,370,373,375,376,380,381,382,384,385,387,390,395,398,400,401,402,403,404,405,406,408,410,415,417,419,420,424,425,428,429,430,431,432,435,437,438,439,440,444,445,447,448,450,452,453,455,457,460,462,463,465,466,467,469,470,474,475,477,478,480,483,484,485,489,490,494,495,498,500,502,505,508,510,511,515,516,519,520,524,525,528,530,531,532,533,534,535,537,538,540,542,545,550,552,553,554,555,558,559,560,564,565,570,571,574,575,576,577,580,584,585,589,590,594,595,596,598,600,601,602,605,606,607,609,610,612,613,615,616,620,623,625,630,633,635,638,640,643,645,650,653,655,660,665,666,667,670,672,675,676,680,686,687,690,692,697,700,702,704,705,707,710,715,720,725,727,730,735,736,737,740,744,745,748,750,756,760,762,764,765,766,767,768,769,770,772,775,777,778,780,781,788,790,795,798,800,802,804,807,810,812,815,816,818,820,825,827,830,834,835,840,845,847,850,855,860,862,864,865,868,870,875,876,877,878,880,885,886,890,898,899,900,902,903,905,910,911,912,914,915,918,920,924,925,929,930,935,945,952,953,955,960,970,975,978,980,988,997,1000,1002,1004,1006,1021,1022,1025,1030,1034,1039,1040,1043,1050,1055,1058,1060,1070,1080,1090,1100,1106,1110,1111,1114,1118,1120,1125,1127,1130,1135,1143,1152,1160,1166,1180,1190,1195,1199,1200,1203,1205,1210,1215,1216,1217,1218,1219,1220,1223,1225,1226,1227,1228,1230,1233,1234,1237,1238,1240,1245,1247,1250,1253,1254,1255,1259,1260,1262,1270,1272,1275,1276,1280,1282,1285,1290,1292,1295,1300,1303,1305,1310,1315,1321,1325,1327,1330,1335,1340,1341,1345,1347,1350,1355,1360,1368,1370,1380,1385,1388,1390,1395,1400,1410,1418,1420,1425,1435,1438,1440,1446,1450,1454,1460,1462,1466,1468,1469,1480,1485,1497,1499,1500,1505,1508,1510,1520,1523,1524,1529,1530,1540,1555,1560,1580,1585,1600,1603,1610,1617,1634,1640,1650,1656,1657,1660,1665,1670,1672,1675,1680,1697,1705,1710,1720,1721,1725,1727,1728,1746,1750,1752,1765,1780,1788,1790,1795,1796,1798,1800,1806,1810,1814,1815,1816,1820,1823,1824,1825,1829,1830,1835,1838,1840,1845,1846,1850,1862,1875,1880,1885,1890,1900,1910,1930,1935,1940,1955,1962,1970,1975,1997,2000,2002,2005,2010,2017,2020,2025,2030,2035,2040,2045,2080,2085,2100,2104,2123,2140,2180,2189,2195,2210,2219,2230,2240,2260,2285,2300,2324,2340,2350,2360,2393,2400,2401,2476,2480,2500,2505,2506,2508,2537,2540,2542,2550,2555,2560,2580,2590,2605,2650,2775,2795,2805,2866,2950,3260,3290,3418],"custom.product_depth_mm":[20,27,30,40,42,50,60,81,85,100,108,114,115,120,124,125,130,135,145,150,155,160,162,165,170,172,175,176,177,178,180,185,190,192,197,200,202,205,207,210,215,216,217,220,226,228,229,230,233,234,236,240,245,247,250,255,260,261,265,266,270,271,275,280,281,282,287,290,295,300,304,305,306,310,311,315,316,319,320,325,327,328,329,330,332,334,335,340,343,345,346,347,350,352,353,355,356,359,360,361,362,363,365,368,370,375,376,378,380,381,382,383,384,385,386,389,390,391,392,393,395,397,398,400,405,407,408,410,412,415,418,420,425,429,430,431,432,434,435,437,439,440,442,443,444,445,450,451,455,456,457,460,465,466,470,471,472,475,477,478,480,482,485,486,488,489,490,493,495,496,500,503,504,505,506,507,508,510,511,512,513,514,515,517,518,520,522,525,528,529,530,532,534,535,537,540,541,543,545,546,550,553,555,557,558,560,561,562,563,564,565,566,568,569,570,571,574,575,576,577,580,584,585,590,591,593,595,598,600,601,602,603,604,605,607,608,609,610,612,614,615,616,619,620,621,624,625,626,628,630,631,632,635,638,639,640,642,643,645,649,650,651,652,653,654,655,660,662,663,665,666,668,670,675,676,677,678,680,681,684,685,686,687,690,693,695,696,700,702,703,705,707,708,710,712,719,720,724,725,726,727,730,733,734,735,738,740,741,743,745,750,754,755,759,760,761,762,764,765,768,769,770,771,773,775,780,782,784,787,790,792,795,800,804,805,810,815,816,817,818,819,820,823,824,826,827,830,835,836,838,840,845,846,850,851,855,858,860,865,867,870,872,880,885,889,890,891,893,895,900,902,910,914,915,919,920,922,923,930,940,945,950,960,964,965,970,975,979,982,990,1000,1005,1010,1015,1020,1030,1040,1043,1080,1085,1095,1100,1110,1115,1140,1145,1160,1165,1170,1175,1180,1200,1219,1224,1250,1255,1270,1305,1320,1355,1362,1425,1440,1465,1468,1469,1570,1620,1765,1920,2065,2210,2350,2365,2590],"custom.product_height_mm":[10,12,15,19,20,22,24,25,27,30,32,35,36,37,39,40,42,45,50,51,55,56,60,61,62,65,66,70,72,73,80,84,85,100,101,105,107,111,115,120,125,126,130,135,140,145,150,160,170,172,174,180,185,190,195,200,202,205,208,210,213,215,220,223,225,228,230,235,236,238,240,241,242,244,245,246,247,248,250,253,255,260,263,264,265,270,274,275,280,281,284,285,286,288,289,290,292,295,300,302,305,310,311,315,320,325,327,328,330,331,335,336,340,343,345,348,350,355,357,360,362,366,368,370,372,374,375,376,378,379,380,381,385,390,393,395,398,400,403,406,410,412,413,415,420,422,424,425,428,429,430,432,433,434,435,436,437,439,440,441,445,448,450,455,456,457,460,461,464,465,470,474,475,476,480,485,486,487,489,490,493,495,497,500,505,507,510,512,513,514,515,516,517,520,521,525,526,527,528,530,533,535,537,538,540,546,547,548,550,552,555,557,560,562,565,568,570,572,574,575,576,577,579,580,585,586,587,590,595,596,597,600,603,604,605,606,607,610,613,618,620,621,623,630,635,640,644,650,652,653,655,658,659,660,665,668,670,675,676,677,678,680,681,683,685,686,687,689,690,691,695,700,701,702,704,710,711,712,718,720,725,730,735,740,744,745,749,750,755,756,760,762,763,765,766,770,775,780,783,787,789,790,791,794,795,800,802,803,805,806,810,815,820,825,826,829,830,831,832,835,838,840,842,843,844,845,846,849,850,855,858,860,865,868,870,873,874,875,880,883,885,887,888,890,892,894,895,897,898,900,903,905,907,908,910,911,914,915,919,920,922,923,927,928,929,930,932,937,940,942,950,953,955,960,965,967,969,970,972,975,978,980,988,990,995,1000,1010,1011,1013,1015,1020,1024,1025,1026,1030,1035,1044,1050,1051,1059,1060,1063,1070,1071,1080,1085,1090,1093,1095,1097,1098,1100,1107,1110,1111,1115,1117,1120,1122,1128,1130,1140,1149,1150,1154,1168,1170,1175,1178,1180,1190,1192,1194,1195,1200,1215,1224,1226,1230,1250,1255,1260,1270,1275,1280,1282,1288,1290,1293,1295,1300,1310,1312,1316,1318,1320,1325,1330,1333,1346,1350,1353,1355,1356,1360,1370,1372,1380,1384,1385,1393,1400,1406,1430,1438,1450,1459,1460,1472,1477,1480,1491,1500,1510,1520,1535,1540,1550,1560,1575,1580,1590,1600,1618,1650,1680,1690,1692,1693,1720,1725,1732,1735,1740,1742,1745,1758,1763,1770,1775,1795,1800,1810,1820,1840,1841,1850,1853,1855,1872,1880,1882,1885,1890,1895,1900,1915,1920,1926,1927,1930,1935,1937,1945,1950,1960,1963,1965,1973,1974,1975,1980,1982,1985,1986,1990,1995,2000,2003,2005,2008,2010,2015,2019,2022,2025,2030,2035,2036,2039,2040,2050,2055,2057,2060,2062,2067,2070,2079,2080,2092,2100,2110,2112,2115,2120,2128,2130,2135,2150,2160,2185,2190,2200,2205,2210,2230,2295,2300,2350,2370,2385,2395,2460,2600]};

  /* ☠️ A hard 16 KiB wall on the request URI, measured: 408 values / 16,376
     chars returned 200, 409 / 16,416 returned HTTP 414. Stay well under it and
     leave room for the other filters already in the URL. */
  var URL_BUDGET = 15000;

  /* ☠️☠️ THE WALL THAT BINDS FIRST IS PAGE WEIGHT, NOT URL LENGTH.
     Shopify echoes the whole query string into EVERY facet link twice (href and
     data-url) and into every pagination link, so each extra size inflates the
     HTML of the page it loads. Measured on the live store, 13-08-2026:

        upright-freezers   plain 1.18 MB -> 2.88 MB for 600-900mm  (14.4 KB/size)
        commercial-fridges plain 1.51 MB -> 5.28 MB for 600-900mm  (32.0 KB/size)
        commercial-fridges                  7.82 MB for 600-1200mm (34.2 KB/size)

     A five-megabyte collection page on a phone is not a filter, it is a bill.
     So the number of sizes is capped by an estimate of what they will cost, and
     a band too expensive to spell out exactly falls back to the sizes this page
     rendered — which is precisely what a shopper could reach by ticking boxes
     today, so the cap is never worse than the thing it replaces.
     ★ The estimate is measured per page, because the cost is driven by how many
     facet links the collection has: fridges has 363 of them, upright freezers
     140, and that is the whole difference between 32 KB and 14 KB a size. */
  var WEIGHT_BUDGET = 1500000;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* Roughly what one more size costs this page, in bytes of HTML. Every filter
     link carries the query string twice, every pagination link once. */
  function costPerValue(param) {
    var echoes = document.querySelectorAll('a[data-filter-input]').length * 2
               + document.querySelectorAll('.pagination a, [data-pagination] a').length
               + 8;
    return echoes * (param.length + 6);
  }

  /* Say what was actually asked for. "428 – 1,433mm" reads as a filter on both
     ends when only one end was moved. */
  function phrase(from, to, lo, hi) {
    if (from <= lo && to >= hi) { return 'any size'; }
    if (from <= lo) { return 'up to ' + fmt(to) + 'mm'; }
    if (to >= hi) { return fmt(from) + 'mm and over'; }
    return fmt(from) + '\u2013' + fmt(to) + 'mm';
  }

  function readGroup(group) {
    var links = group.querySelectorAll('a[data-filter-input][data-value]');
    if (!links.length) { return null; }
    var param = links[0].getAttribute('data-name') || group.getAttribute('data-rb-param');
    if (!param || !PARAM_RE.test(param)) { return null; }

    var values = [], active = [], i, raw, m, band;
    for (i = 0; i < links.length; i++) {
      raw = links[i].getAttribute('data-value');
      band = /^(\d+)-(\d+)$/.exec(raw);
      /* ☠️ A size or a band, and nothing else. One value that is neither means
         this is not the filter we think it is, and a slider over it would be
         nonsense. */
      if (!band && !/^\d+$/.test(raw)) { return null; }
      m = (links[i].textContent || '').match(/\((\d[\d,]*)\)/);
      values.push({
        /* v is where the value STARTS and hi is where it ENDS. For an exact
           size they are the same number; for a band they are its two edges,
           and both matter when deciding what a drag covers. */
        v: parseInt(band ? band[1] : raw, 10),
        hi: parseInt(band ? band[2] : raw, 10),
        raw: raw,
        c: m ? parseInt(m[1].replace(/,/g, ''), 10) : 0
      });
      if (links[i].hasAttribute('data-filter-active')) {
        active.push(parseInt(band ? band[1] : raw, 10));
      }
    }
    values.sort(function (a, b) { return a.v - b.v; });
    /* One anchor per distinct value is what Shopify renders, but a duplicate
       would be submitted twice and counted twice — inflating both the URL and
       the page-weight estimate for no gain. Cheap to rule out. */
    var uniq = [], u;
    for (u = 0; u < values.length; u++) {
      if (!uniq.length || uniq[uniq.length - 1].raw !== values[u].raw) { uniq.push(values[u]); }
    }
    values = uniq;
    if (values.length < MIN_VALUES) { return null; }
    return { param: param, values: values, active: active,
             banded: /_band$/.test(param) };
  }

  function build(group, data) {
    var values = data.values;
    /* The TRACK is scoped to this collection — a freezer page should not offer
       a 3,418mm handle because a bench somewhere is that wide. (REO gets this
       right too; what REO gets wrong is re-scoping the track to your SELECTION,
       so you can never widen it again. This never moves.) */
    var lo = values[0].v, hi = values[0].hi, k;
    for (k = 0; k < values.length; k++) { if (values[k].hi > hi) { hi = values[k].hi; } }
    var span = Math.max(1, hi - lo);
    /* Exactly 100 rendered means Shopify almost certainly cut the list. Bands
       never come close — 60 widths, 38 depths, 50 heights across all of CE. */
    var truncated = values.length >= 100;
    var key = data.param.replace(/^filter\.[pv]\.m\./, '');
    /* ☠️ The baked list is EXACT SIZES. Unioning it into a BAND filter would
       submit "600" to a filter whose values are all "0600-0649", which matches
       nothing — and an unmatched filter value returns an empty grid. Bands are
       complete on their own, so they never need it. */
    var full = data.banded ? [] : (STORE[key] || []);
    /* Re-opening a filtered page: the handles sit on what is actually applied.
       A bookmarked URL with gaps in it (someone ticked 600 and 900 but not 700)
       shows as 600–900; applying again makes it a true range. */
    var from = data.active.length ? Math.min.apply(null, data.active) : lo;
    var to = data.active.length ? Math.max.apply(null, data.active) : hi;

    var el = document.createElement('div');
    el.className = 'rbdr';
    el.innerHTML =
      '<div class="rbdr-fields">' +
        '<span class="rbdr-field"><input type="number" class="rbdr-from" inputmode="numeric">' +
          '<span class="rbdr-unit">mm</span></span>' +
        '<span class="rbdr-dash">\u2013</span>' +
        '<span class="rbdr-field"><input type="number" class="rbdr-to" inputmode="numeric">' +
          '<span class="rbdr-unit">mm</span></span>' +
      '</div>' +
      '<div class="rbdr-plot"></div>' +
      '<div class="rbdr-slider"><div class="rbdr-track"></div><div class="rbdr-fill"></div>' +
        '<input type="range" class="rbdr-h1"><input type="range" class="rbdr-h2"></div>' +
      '<div class="rbdr-ends"><span>' + fmt(lo) + 'mm</span><span>' + fmt(hi) + 'mm</span></div>' +
      '<div class="rbdr-foot"><span class="rbdr-count"></span>' +
        '<span class="rbdr-actions"></span></div>';

    var fromI = el.querySelector('.rbdr-from'), toI = el.querySelector('.rbdr-to');
    var h1 = el.querySelector('.rbdr-h1'), h2 = el.querySelector('.rbdr-h2');
    var fill = el.querySelector('.rbdr-fill'), plot = el.querySelector('.rbdr-plot');
    var countEl = el.querySelector('.rbdr-count'), actions = el.querySelector('.rbdr-actions');

    var label = (group.querySelector('.collection-filters__filter-title') || {}).textContent || '';
    fromI.setAttribute('aria-label', label.trim() + ' from, in millimetres');
    toI.setAttribute('aria-label', label.trim() + ' to, in millimetres');
    h1.setAttribute('aria-label', label.trim() + ' minimum');
    h2.setAttribute('aria-label', label.trim() + ' maximum');
    [h1, h2].forEach(function (h) { h.min = lo; h.max = hi; h.step = 1; });

    /* Where the stock actually sits, so a buyer can see at a glance which part
       of the track is worth dragging into.
       ☠️ Do NOT read this as "equipment comes in round sizes" — measured over
       all 3,581 CE products with dimensions, 600/900/1200/1500/1800 account for
       only 18.5% of widths and just 27% of widths are even a multiple of 100.
       That is precisely why a range beats a checkbox list here: there is no
       short list of sizes to offer. */
    var bars = [], buckets = [], i;
    for (i = 0; i < BARS; i++) { buckets.push(0); }
    values.forEach(function (p) {
      buckets[Math.min(BARS - 1, Math.floor((p.v - lo) / span * BARS))] += p.c;
    });
    var peak = Math.max.apply(null, buckets) || 1;
    for (i = 0; i < BARS; i++) {
      var b = document.createElement('i');
      b.style.height = Math.max(2, Math.round(buckets[i] / peak * 26)) + 'px';
      plot.appendChild(b);
      bars.push(b);
    }

    var applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'rbdr-apply';
    applyBtn.textContent = 'Apply';
    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'rbdr-clear';
    clearBtn.textContent = 'Any size';

    function inRange() {
      var n = 0;
      values.forEach(function (p) { if (p.v >= from && p.hi <= to) { n += p.c; } });
      return n;
    }
    function isWhole() { return from <= lo && to >= hi; }
    function isApplied() { return data.active.length > 0; }

    function paint() {
      /* ★ Empty means "no limit", the way the theme's own price boxes read.
         REO fills theirs with the catalogue floor — "0.00" — which looks like a
         filter nobody set and quietly sweeps in every product with no size at
         all. A box we have not been given a number for stays blank. */
      fromI.value = (from <= lo) ? '' : from;
      toI.value = (to >= hi) ? '' : to;
      fromI.placeholder = lo;
      toI.placeholder = hi;
      h1.value = from; h2.value = to;
      var a = (from - lo) / span * 100, z = (to - lo) / span * 100;
      fill.style.left = a + '%';
      fill.style.width = Math.max(0, z - a) + '%';
      for (var j = 0; j < BARS; j++) {
        var mid = lo + (j + 0.5) / BARS * span;
        bars[j].className = (mid >= from && mid <= to) ? 'on' : '';
      }
      /* \u2620\ufe0f Only claim a number when we can stand behind it. The counts come from
         the rendered facet; if that list was cut at 100 the sum understates the
         result, and a count that disagrees with the grid is worse than none. */
      var n = inRange();
      if (truncated) {
        countEl.textContent = phrase(from, to, lo, hi);
      } else {
        countEl.textContent = n === 0
          ? 'No products this size'
          : fmt(n) + ' product' + (n === 1 ? '' : 's') + ' \u00b7 ' + phrase(from, to, lo, hi);
      }
      countEl.className = 'rbdr-count' + (!truncated && n === 0 ? ' rbdr-none' : '');

      actions.innerHTML = '';
      /* Nothing to apply when the handles are where the page already is. */
      var dirty = isWhole() ? isApplied()
                            : (from !== (data.active.length ? Math.min.apply(null, data.active) : lo) ||
                               to !== (data.active.length ? Math.max.apply(null, data.active) : hi));
      if (isWhole() && isApplied()) { actions.appendChild(clearBtn); }
      else if (dirty) {
        applyBtn.disabled = (!truncated && n === 0);
        actions.appendChild(applyBtn);
      } else if (isApplied()) { actions.appendChild(clearBtn); }
    }

    /* ☠️ An emptied box means "no limit on this end", so it falls back to that
       end of the track — not to zero and not to the other handle. Clearing the
       To box with a lo-default would have collapsed the range onto From and
       shown one size. */
    function clamp(v, dflt) {
      v = parseInt(v, 10);
      if (isNaN(v)) { return dflt; }
      return Math.max(lo, Math.min(hi, v));
    }
    function setFrom(v) { from = Math.min(clamp(v, lo), to); paint(); }
    function setTo(v) { to = Math.max(clamp(v, hi), from); paint(); }

    h1.addEventListener('input', function () { setFrom(h1.value); });
    h2.addEventListener('input', function () { setTo(h2.value); });
    /* Apply on release, not on every frame: each apply is a page load. */
    h1.addEventListener('change', go);
    h2.addEventListener('change', go);
    fromI.addEventListener('change', function () { setFrom(fromI.value); });
    toI.addEventListener('change', function () { setTo(toI.value); });
    [fromI, toI].forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); go(); }
      });
    });
    applyBtn.addEventListener('click', go);
    clearBtn.addEventListener('click', function () { from = lo; to = hi; go(); });

    /* ☠️ UNION, never "the baked list if there is one". CF has dimensions on 6
       of 1,822 products, so a store list can be far SHORTER than what a
       collection rendered; preferring it would drop nearly everything. The
       union is never worse than either source, and it also survives the baked
       list going stale between deploys. */
    function sourceValues() {
      if (!full.length) { return values; }
      var seen = {}, out = [], i, k;
      for (i = 0; i < values.length; i++) { seen[values[i].v] = 1; }
      for (i = 0; i < full.length; i++) { seen[full[i]] = 1; }
      for (k in seen) {
        if (Object.prototype.hasOwnProperty.call(seen, k)) {
          out.push({ v: parseInt(k, 10), hi: parseInt(k, 10), raw: k });
        }
      }
      out.sort(function (a, b) { return a.v - b.v; });
      return out;
    }

    /* Which sizes to submit. A handle parked on the end of its track means
       "and everything past this", not "exactly the biggest size this page
       happened to render" — which is how a 2,866mm fridge stays reachable even
       though the sidebar's list stopped at 2,230. */
    function pick(list) {
      var lowOpen = from <= lo, highOpen = to >= hi, out = [], i;
      for (i = 0; i < list.length; i++) {
        /* ☠️ A band goes in only if it lies WHOLLY inside the selection. Asked
           for "up to 900mm", a shopper must not be shown a 940mm unit because
           it shares the 900-949 band — the whole point of the filter is that
           the thing fits. The applied range is then reported back as what it
           really is (600-899mm), so the number they see is the number they
           got. */
        if ((lowOpen || list[i].v >= from) && (highOpen || list[i].hi <= to)) {
          out.push(list[i]);
        }
      }
      return out;
    }

    function query(picked) {
      var p = new URLSearchParams(window.location.search);
      p.delete(data.param);
      p.delete('page');
      for (var i = 0; i < picked.length; i++) {
        p.append(data.param, picked[i].raw);
      }
      return p.toString();
    }

    function go() {
      if (!truncated && inRange() === 0 && !isWhole()) { paint(); return; }
      var q;
      if (isWhole()) {
        q = query([]);
      } else {
        var picked = pick(sourceValues());
        var maxValues = Math.floor(WEIGHT_BUDGET / Math.max(1, costPerValue(data.param)));
        q = query(picked);
        /* ☠️ Over the 16 KiB wall the storefront answers 414, not "too many";
           over the weight budget it answers 200 with a page nobody on a phone
           should be sent. Either way a band too broad to spell out falls back to
           the sizes this page rendered. That is exactly today's coverage:
           narrower than we'd like, never wrong, and it only happens on bands so
           wide they return most of the catalogue anyway. */
        if (q.length > URL_BUDGET || picked.length > maxValues) {
          q = query(pick(values));
        }
        /* ☠️ Still over: submit nothing rather than a 414. An unknown or
           malformed filter fails OPEN on Shopify — it returns the whole
           catalogue — so a silent overflow would look exactly like "the filter
           did nothing". Better to leave the sizes alone and keep the page. */
        if (q.length > URL_BUDGET) { paint(); return; }
      }
      window.location.search = q ? '?' + q : '';
    }

    paint();
    return el;
  }

  ready(function () {
    var groups = document.querySelectorAll('[data-filter-group]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.getAttribute('data-rb-type') === 'price_range') { return; }
      var data = readGroup(group);
      if (!data) { return; }
      var list = group.querySelector('.collection-filters__filter-list');
      if (!list) { return; }
      var control = build(group, data);
      var item = document.createElement('li');
      item.className = 'rbdr-item';
      item.appendChild(control);
      list.classList.add('rbdr-hid');
      list.insertBefore(item, list.firstChild);
    });
  });
}());
